export function isEqualJson(a, b) {
    return a === b || JSON.stringify(a) === JSON.stringify(b);
}

export function parseJson(json, defaultValue) {
    let result;

    try {
        result = JSON.parse(json);
    } catch (e) {
        result = defaultValue;
    }

    return result;
}

export const cleanObject = obj =>
    obj === null
        ? undefined // null -> undefined
        : Array.isArray(obj)
        ? obj.filter(v => v !== null).map(cleanObject) // Clean array
        : typeof obj === 'object'
        ? Object.keys(obj) // Clean object
              .filter(k => obj[k] !== null)
              .reduce(
                  (target, k) => ({
                      ...target,
                      [k]: cleanObject(obj[k]),
                  }),
                  {}
              )
        : obj;
